// Components/ui
import { Ims } from './components';
// Types
import { NewAddress } from '../../../../../../../../../utils/contactHelper';
import SubsectionBodyContainer from '../../../../shared/SubsectionBodyContainer';
import UseEditContact from '../../../../../../../../../hooks/useEditContact/types/UseEditContact';
import UseEditBusiness from '../../../../../../../../../hooks/useEditBusiness/types/UseEditBusiness';
import { IContactAddress } from '@trii/types/dist/Contacts';

type Props = {
  IMSs: NewAddress[] | IContactAddress[];
  editEntity: UseEditBusiness | UseEditContact;
};

const Body = ({ IMSs, editEntity }: Props) => {
  return (
    <SubsectionBodyContainer>
      {IMSs?.map((ims) => (
        <Ims key={ims.id} data={ims} editEntity={editEntity} />
      ))}
    </SubsectionBodyContainer>
  );
};

export default Body;
